import { render, staticRenderFns } from "./CanvasTour.vue?vue&type=template&id=961603fc"
import script from "./CanvasTour.vue?vue&type=script&lang=js"
export * from "./CanvasTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports